import { useState } from 'react';
import { navLinks } from '@/mocks/home';

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 h-[60px] md:h-[72px] flex items-center bg-background-50/95 backdrop-blur-md border-b border-background-200/70">
      <div className="w-full px-4 md:px-6 flex items-center justify-between">
        <a href="#hero" className="flex items-center gap-2 no-underline">
          <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-primary-500 flex items-center justify-center">
            <i className="ri-play-fill text-background-50 text-lg md:text-xl"></i>
          </div>
          <span className="font-heading font-bold text-sm md:text-base text-foreground-950 whitespace-nowrap">
            91麻豆免费视频网站
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-600 rounded-md hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
          aria-label="菜单"
        >
          <i className={`text-xl text-foreground-700 ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden absolute top-[60px] left-0 right-0 bg-background-50 border-b border-background-200/70">
          <nav className="flex flex-col p-4 gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMobileOpen(false)}
                className="px-4 py-3 text-sm text-foreground-700 hover:text-primary-600 rounded-lg hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}